import { LocalStorageService } from 'ngx-webstorage';

import { Injectable, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeValue } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SaveObjectInLocalServiceService {
  constructor(private readonly storage: LocalStorageService, private readonly sanitizer: DomSanitizer) {}

  setObject(nameObject: string, valueObject: unknown) {
    this.storage.store(nameObject, this.sanitizerObject(JSON.parse(JSON.stringify(valueObject))));
  }

  getObject(nameObject: string): any {
    return this.sanitizerObject(this.storage.retrieve(nameObject));
  }

  removeObject(nameObject: string) {
    this.storage.clear(nameObject);
  }

  sanitizerObject(object: SafeValue | string | null): any {
    return this.sanitizer.sanitize(SecurityContext.HTML, object);
  }
}
